import { Table } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { Inline } from '../inline/inline';
import { BaseTableRow } from './data-table';
import { DataTableGlobalSearch } from './data-table-global-search';
import { DateRangeFilter } from './date-range-filter';
import { DeleteSelectedRowsButton } from './delete-selected-rows-button';

type GlobalSearchConfig =
  | {
      withGlobalSearch: false;
    }
  | {
      withGlobalSearch: true;
      placeholder?: string;
    };

type DataTableFilterControlsProps<TData extends BaseTableRow> = {
  children: ReactNode;
  table: Table<TData>;
  globalSearchConfig?: GlobalSearchConfig;
  withDateRangeFilter?: boolean;
};

export const DataTableFilterControls = <TData extends BaseTableRow>({
  children,
  table,
  globalSearchConfig = { withGlobalSearch: false },
  withDateRangeFilter = false,
}: DataTableFilterControlsProps<TData>) => {
  return (
    <Inline space={4} justify="between" className="flex-1">
      <div className="flex-shrink-0">
        {table.getSelectedRowModel().rows.length > 0 && <DeleteSelectedRowsButton table={table} />}
      </div>

      <Inline space={4} justify="end">
        {withDateRangeFilter && <DateRangeFilter column={table.getColumn('fspDate')} />}

        {children}

        {globalSearchConfig.withGlobalSearch && (
          <DataTableGlobalSearch table={table} placeholder={globalSearchConfig.placeholder} />
        )}
      </Inline>
    </Inline>
  );
};
